module.exports = __webpack_public_path__ + "img/2019_f_ns_ad_s.898cc1b0.jpg";